<template>
  <CAlert v-if="visible" :color="message.color" class="session-notice" role="alert">
    <div class="session-notice__inner">
      <CIcon name="cil-warning" class="session-notice__icon"/>
      <div class="session-notice__copy">
        <strong>{{ $t(message.title) }}</strong>
        <p>{{ $t(message.text) }}</p>
      </div>
      <button
        type="button"
        class="session-notice__dismiss"
        :aria-label="$t('session_notice_dismiss')"
        @click="dismiss"
      >
        <CIcon name="cil-x"/>
      </button>
    </div>
  </CAlert>
</template>

<script>
const messages = {
  fingerprint_mismatch: {
    color: 'danger',
    title: 'session_notice_fingerprint_title',
    text: 'session_notice_fingerprint_text'
  },
  session_expired: {
    color: 'warning',
    title: 'session_notice_expired_title',
    text: 'session_notice_expired_text'
  },
  session_revoked: {
    color: 'info',
    title: 'session_notice_revoked_title',
    text: 'session_notice_revoked_text'
  }
}

export default {
  name: 'SessionNotice',
  computed: {
    reason () {
      return this.$store.getters.SessionNotice
    },
    message () {
      return messages[this.reason] || messages.session_revoked
    },
    visible () {
      return Boolean(messages[this.reason])
    }
  },
  methods: {
    dismiss () {
      this.$store.dispatch('dismissSessionNotice')
    }
  }
}
</script>
